import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgEmblemActiveEmployer = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ActiveEmployer</title>
    <mask
      id="emblem-active-employer_svg__a"
      maskUnits="userSpaceOnUse"
      x={6.267}
      y={1.4}
      width={20}
      height={29}
      fill="#000"
    >
      <path fill="#fff" d="M6.267 1.4h20v29h-20z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M17.19 13.918V4.4L8.267 18.082h6.543V27.6l8.923-13.682H17.19Z" />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.19 13.918V4.4L8.267 18.082h6.543V27.6l8.923-13.682H17.19Z"
      fill="#FFE045"
    />
    <path
      d="M17.19 13.918h-2a2 2 0 0 0 2 2v-2Zm0-9.518h2a2 2 0 0 0-3.675-1.093L17.19 4.4ZM8.267 18.082l-1.675-1.093a2 2 0 0 0 1.675 3.093v-2Zm6.543 0h2a2 2 0 0 0-2-2v2Zm0 9.518h-2a2 2 0 0 0 3.675 1.092L14.81 27.6Zm8.923-13.682 1.675 1.092a2 2 0 0 0-1.675-3.092v2Zm-4.543 0V4.4h-4v9.518h4Zm-3.675-10.61L6.592 16.988l3.35 2.185 8.924-13.682-3.35-2.185ZM8.267 20.081h6.543v-4H8.267v4Zm4.543-2V27.6h4v-9.518h-4Zm3.675 10.61 8.923-13.682-3.35-2.185-8.924 13.682 3.35 2.185Zm7.248-16.774H17.19v4h6.543v-4Z"
      fill="#2F3639"
      mask="url(#emblem-active-employer_svg__a)"
    />
    <path d="M14.805 15.702V8.055l2.38-3.655v9.518h6.543L14.805 27.6l4.759-11.898h-4.76Z" fill="#FFF8D6" />
  </svg>
);
export default SvgEmblemActiveEmployer;
